import React from 'react';
import LeChetom from '../components/LeChetom';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <LeChetom />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
